export function RichText({ html, className = "", testid }) {
    if (!html) return null;
    // Le HTML est assaini côté serveur (liste blanche stricte) avant stockage.
    return <div className={`rich-text ${className}`} dangerouslySetInnerHTML={{ __html: html }} data-testid={testid} />;
}

export function SectionBody({ sec, className = "", testid }) {
    if (!sec) return null;
    if (sec.body_format === "html" && sec.body_html) {
        return <RichText html={sec.body_html} className={className} testid={testid} />;
    }
    if (!sec.body) return null;
    return (
        <p className={`whitespace-pre-line ${className}`} data-testid={testid}>
            {sec.body}
        </p>
    );
}
